import commonScripts from './common';

// window.addEventListener('load', () => {
window.addEventListener('DOMContentLoaded', () => {
	commonScripts();
});
